import ReactDOM from "react-dom";
import AuthPC from "./pc/customAuth";
import "./index.css";
import { getPcDom } from "./utils";

ReactDOM.render(getPcDom(AuthPC), document.getElementById("root"));
